import React, { useState, useMemo, useCallback } from 'react';
import { Rectangle, Tooltip, Marker } from 'react-leaflet'; // On retire Circle car plus utilisé
import L from 'leaflet';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { addBreakTime } from '../../../CoffeePause/store/coffePauseThunks';
import { startPause } from '../../../CoffeePause/store/coffePauseSlice';
import { joinRoom } from '../../../ControlPanel/store/interact/interactThunks';
import { addNotification } from '../../../Notifications/store/notificationsSlice';
import { setJoinBy, setTargetRoom } from '../../../ProductivitySession/store/ProductivitySessionSlice';
import { setOpenModal } from '../../../ControlPanel/store/controlPanelSlice';
import NotificationBuilder from '../../../Notifications/utils/NotificationBuilder';

// Icône transparente pour le marker invisible
const invisibleIcon = L.divIcon({
    className: '',
    iconSize: [0, 0],
    iconAnchor: [0, 0],
});

export default function CibleCliquable() {
    const [hoveredId, setHoveredId] = useState(null);
    const { localAvatar } = useSelector(state => state.auth);
    const { roomsData } = useSelector((state) => state.MapDisplay);
    const {
        cafePauseActive,

    } = useSelector((state) => state.coffePause);
       const {
            sessionView,
        } = useSelector((state) => state.productivitySession);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const dynamicObjects = useMemo(() => {
        if (!roomsData || !Array.isArray(roomsData)) return [];

        return roomsData.flatMap((room) => {
            const objects = room.map_clickable_objects;
            const items = Array.isArray(objects)
                ? objects
                : (objects ? Object.values(objects) : []);

            return items.map((obj) => ({
                ...obj,
                uniqueKey: `room-${room.room_id}-obj-${obj.id}`,
                roomId: room.room_id
            }));
        });
    }, [roomsData]);

    const onConfirm = useCallback(async (obj) => {
        try {
            if (sessionView !== "progress" && localAvatar?.focus_state === 0) {
                const isoTime = new Date().toISOString();
                dispatch(startPause(localAvatar.id));
                dispatch(addBreakTime({ body: { userId: localAvatar.id, time: isoTime } }));
                const notification = NotificationBuilder.info()
                    .withHeader('start_pause', true)
                    .build();
                dispatch(addNotification(notification));
                dispatch(joinRoom({ body: { targetRoomId: obj.roomId } })).unwrap();

            }
            else if (sessionView === "progress" && localAvatar?.focus_state === 1) {
                dispatch(setJoinBy("coffee"));
                dispatch(setTargetRoom(obj.roomId));
                dispatch(setOpenModal("stop_focus"));
            }
        } catch (error) {
            console.error("Error in onConfirm:", error);
        }
    }, [localAvatar?.id, t , sessionView , localAvatar?.focus_state]);

    const handleClick = (e, obj) => {
        L.DomEvent.stopPropagation(e);
        onConfirm(obj);
    };

    return (
        <>
            {dynamicObjects.map((obj) => {
                if (!obj.lat || !obj.lng || obj.name !== "coffee_machine" || ( cafePauseActive)) return null;
                const isHovered = hoveredId === obj.uniqueKey;
                const w = 1.7;
                const h = 2.5;
                const bounds = [
                    [obj.lat - (h / 2), obj.lng - (w / 2)],
                    [obj.lat + (h / 2), obj.lng + (w / 2)]
                ];
                // Point ancré au bord supérieur du rectangle, en coordonnées geo
                const topCenter = [obj.lat + (h / 2), obj.lng];

                return (
                    <React.Fragment key={obj.uniqueKey}>
                        <Rectangle
                            bounds={bounds}
                            pathOptions={{
                                stroke: false,
                                fillColor: "white",
                                fillOpacity: isHovered ? 0.3 : 0,
                                interactive: true,
                                
                            }}
                            eventHandlers={{
                                click: (e) => handleClick(e, obj),
                                mouseover: () => setHoveredId(obj.uniqueKey),
                                mouseout: () => setHoveredId(null),
                            }}
                        />
                        {isHovered && (
                            <Marker
                                position={topCenter}
                                icon={invisibleIcon}
                                interactive={false}
                            >
                                <Tooltip
                                    direction="top"
                                    opacity={1}
                                    permanent
                                    className="coffee-tooltip"
                                >
                                    Prendre un café
                                </Tooltip>
                            </Marker>
                        )}
                    </React.Fragment>
                );
            })}
        </>
    );
}